'use client';
import { useEffect, useRef } from 'react';

export const useRevealOnGrow = (count: number) => {
  const bodyRef = useRef<HTMLDivElement>(null);
  const previousCount = useRef(count);

  useEffect(() => {
    const body = bodyRef.current;
    if (body && count > previousCount.current) {
      body.scrollTo({ behavior: 'smooth', top: body.scrollTop + body.clientHeight });
    }
    previousCount.current = count;
  }, [count]);

  return bodyRef;
};
